import { Grid } from '@material-ui/core';
import { EnderecoForm } from 'app/main/pessoa/Endereco';
import React from 'react';

const TabEnderecoVendedor = () => {
  return (
    <Grid container spacing={3}>
      <EnderecoForm />
    </Grid>
  );
};

export default TabEnderecoVendedor;
